/* Treasure Vault — small production runtime safeguards. */
(function(){
  'use strict';
  if(!window.Vault) return;
  var V = window.Vault;

  /* Keep scroll locking correct when one overlay closes while another is open. */
  var overlays = [
    document.getElementById('menu-drawer'),
    document.querySelector('[data-cart-drawer]'),
    document.querySelector('[data-search-modal]'),
    document.querySelector('[data-coll-filters]')
  ].filter(Boolean);
  function syncScrollLock(){
    var locked = overlays.some(function(el){ return el.classList.contains('is-open'); });
    document.body.classList.toggle('no-scroll', locked);
  }
  if('MutationObserver' in window){
    overlays.forEach(function(el){
      new MutationObserver(syncScrollLock).observe(el,{attributes:true,attributeFilter:['class']});
    });
  }

  /* Collection filter is modal only below the desktop sidebar breakpoint. */
  var filters = document.querySelector('[data-coll-filters]');
  if(filters){
    var mq = window.matchMedia('(min-width:1025px)');
    function syncFilterMode(){
      if(mq.matches){
        var wasOpen = filters.classList.contains('is-open');
        filters.classList.remove('is-open');
        filters.removeAttribute('aria-hidden');
        filters.removeAttribute('role');
        filters.removeAttribute('aria-modal');
        var scrim = document.querySelector('.coll-filters-scrim');
        if(scrim){ scrim.classList.remove('is-open'); scrim.setAttribute('aria-hidden','true'); }
        if(wasOpen && V.releaseFocus) V.releaseFocus(filters);
      } else if(!filters.classList.contains('is-open')){
        filters.setAttribute('aria-hidden','true');
        filters.removeAttribute('role');
        filters.removeAttribute('aria-modal');
      }
      syncScrollLock();
    }
    if(mq.addEventListener) mq.addEventListener('change',syncFilterMode);
    else if(mq.addListener) mq.addListener(syncFilterMode);
    syncFilterMode();
  } else {
    syncScrollLock();
  }

  /* Touch mega-menu: first tap opens, second tap follows the real collection link. */
  document.addEventListener('click',function(e){
    var link = e.target.closest('[data-mega-trigger] .nav-link');
    if(!link || window.matchMedia('(hover: hover)').matches) return;
    if(link.getAttribute('aria-expanded') === 'true'){
      e.stopImmediatePropagation();
      /* Do not preventDefault: this tap should navigate. */
    }
  },true);

  /* Keyboard links stay links: Enter navigates; ArrowDown/Space can open the menu. */
  document.addEventListener('keydown',function(e){
    var link = e.target.closest && e.target.closest('[data-mega-trigger] .nav-link');
    if(link && e.key === 'Enter') e.stopImmediatePropagation();
  },true);

  /* When Klaviyo upgrades the visible fallback restock link, keep it on-page. */
  document.addEventListener('click',function(e){
    var btn = e.target.closest('[data-notify-me][data-notify-has-fallback]');
    if(!btn || !window.klaviyo || typeof window.klaviyo.push !== 'function') return;
    e.preventDefault();
  });

  /* Never expose a dead restock control. A real fallback link can always show on
     sold-out variants; the app-only button waits until Klaviyo is actually ready. */
  function syncRestockAction(){
    var btn = document.querySelector('[data-notify-me]');
    if(!btn) return;
    var atc = document.querySelector('[data-atc]');
    var unavailable = !!(atc && atc.disabled);
    if(!unavailable){ btn.hidden = true; return; }
    var hasFallback = btn.hasAttribute('data-notify-has-fallback');
    var klaviyoReady = !!(window.klaviyo && typeof window.klaviyo.push === 'function');
    btn.hidden = !(hasFallback || klaviyoReady);
  }
  syncRestockAction();
  document.addEventListener('variant:changed',function(){ setTimeout(syncRestockAction,0); });
})();